module.exports = __webpack_public_path__ + "media/img/logos/tak_gov_icon_text-f0b84e60d732ad8a523816260de86ae5.svg";